export default {
  id: 'trade-history',
  title: 'Trade History',
  content: `## Trade History

Trade History is the permanent record of every trade you have completed — entries, exits, P&L, and the conditions around each trade.

---

## Where to Find It

**Orders tab → Trade History** (or History tab)

Also accessible from: **Profile → Trade Analysis**

---

## What Each Record Shows

| Column | Description |
|---|---|
| Symbol | Stock traded |
| Entry Date | Date and time the position was opened |
| Exit Date | Date and time the position was closed |
| Entry Price | Price at which you bought |
| Exit Price | Price at which you sold |
| Quantity | Number of shares |
| Trade Value | Entry Price × Quantity |
| P&L (₹) | (Exit Price − Entry Price) × Quantity |
| P&L (%) | P&L as a % of Trade Value |
| Trade Type | INTRADAY or DELIVERY |
| Exit Reason | MANUAL / STOP_LOSS / TARGET / AUTO_EXIT |
| Source | MANUAL / ALGO_FLOW / NYX_AI |

---

## Exit Reason Column

This column tells you **why** the position was closed — not just when.

| Exit Reason | What happened |
|---|---|
| MANUAL | You tapped Exit manually |
| STOP_LOSS | Position hit your set Stop Loss price and was auto-exited |
| TARGET | Position hit your set Target price and was auto-exited |
| AUTO_EXIT | Intraday position force-closed at 3:10 PM IST |

A high proportion of STOP_LOSS exits is normal and healthy — it means your risk management is working. A high proportion of AUTO_EXIT suggests you are not managing intraday trades actively.

---

## Filtering Trade History

You can filter by:
- Date range (today, last 7 days, last 30 days, custom)
- Symbol
- Trade Type (INTRADAY / DELIVERY)
- Source (MANUAL / ALGO_FLOW / NYX_AI)
- Outcome (Profit / Loss)

---

## What to Look For When Reviewing

- **Average win vs average loss** — is your average win larger than your average loss?
- **Win rate by trade type** — do your DELIVERY trades outperform your INTRADAY trades or vice versa?
- **Stop loss hit rate** — are your stops getting hit often? If yes, are your stops too tight for the stock's normal volatility?
- **Auto-exit rate** — trades exited by AUTO_EXIT at 3:10 PM that are in loss suggest you held past your stop hoping for a recovery

Your Trade History feeds directly into the **Trade Analysis** and **Trade Reports** sections for deeper analysis.`,
};
